export type SVGElement = {
  viewbox: string,
  paths?: string,
  points?: string,
}

type Holder = {
  [key: string]: SVGElement,
}

const NavMenu: Holder = {
  viewbox: '0 0 40 40',
  paths:
    'M7.5,28 L32.5,28 C32.7761424,28 33,28.2238576 33,28.5 L33,30.5 C33,30.7761424 32.7761424,31 32.5,31 L7.5,31 C7.22385763,31 7,30.7761424 7,30.5 L7,28.5 C7,28.2238576 7.22385763,28 7.5,28 Z M7.5,10 L32.5,10 C32.7761424,10 33,10.2238576 33,10.5 L33,12.5 C33,12.7761424 32.7761424,13 32.5,13 L7.5,13 C7.22385763,13 7,12.7761424 7,12.5 L7,10.5 C7,10.2238576 7.22385763,10 7.5,10 Z M7.5,19 L32.5,19 C32.7761424,19 33,19.2238576 33,19.5 L33,21.5 C33,21.7761424 32.7761424,22 32.5,22 L7.5,22 C7.22385763,22 7,21.7761424 7,21.5 L7,19.5 C7,19.2238576 7.22385763,19 7.5,19 Z',
}

const UIDropdown: Holder = {
  viewbox: '0 0 20 20',
  points: '18.215 5 10.031 13.369 1.723 5.185 0 6.969 10.092 16.877 20 6.723',
}

const UIFilter: Holder = {
  viewbox: '0 0 20 20',
  paths:
    'M20,3.9567053 C20,4.76114727 19.3479786,5.41341059 18.5432947,5.41341059 L1.4567053,5.41341059 C0.652263325,5.41341059 -2.84217094e-14,4.7613892 -2.84217094e-14,3.9567053 C-2.84217094e-14,3.15226332 0.652021387,2.5 1.4567053,2.5 L18.5435366,2.5 C19.3479786,2.5 20,3.15226332 20,3.9567053 Z M17.5806257,10.0784482 C17.5806257,10.8828902 16.9286043,11.5351535 16.1239204,11.5351535 L3.87607965,11.5351535 C3.07163767,11.5351535 2.41937435,10.8831321 2.41937435,10.0784482 C2.41937435,9.27400624 3.07139574,8.62174292 3.87607965,8.62174292 L16.1241623,8.62174292 C16.9286043,8.62174292 17.5806257,9.27400624 17.5806257,10.0784482 Z M13.9515641,16.1999492 C13.9515641,17.0043912 13.2995427,17.6566545 12.4948588,17.6566545 L7.50514117,17.6566545 C6.7006992,17.6566545 6.04843587,17.0046331 6.04843587,16.1999492 C6.04843587,15.3955072 6.70045726,14.7432439 7.50514117,14.7432439 L12.4951008,14.7432439 C13.2995427,14.7432439 13.9515641,15.3955072 13.9515641,16.1999492 Z',
}

const icons: Holder = {
  NavMenu,
  UIDropdown,
  UIFilter,
}

export default icons
